import type { Feature } from '../../types';

interface FeatureSectionProps {
  features: Feature[];
}

const FeatureSection = ({ features }: FeatureSectionProps) => {
  return (
    <section className="section section-tight">
      <div className="container feature-grid">
        {features.map((feature) => (
          <article key={feature.id} className="feature-card">
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default FeatureSection;
